import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

class Footer extends Component {
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  render() {
    return (
      <footer className="footer-container">
        <div className="footer-content">
          <div className="footer-top-row">
            <div className="footer-brand-box">
              <Link to="/" className="footer-brand-link" onClick={this.scrollToTop}>
                <span className="footer-brand-mark">RP</span>
                <div>
                  <h4 className="footer-brand-name">Rudraksh Pathak</h4>
                  <p className="footer-brand-tagline">Senior Software Engineer &amp; Application Architect</p>
                </div>
              </Link>
            </div>

            <div className="footer-nav-links">
              <Link to="/" onClick={this.scrollToTop}>Home</Link>
              <Link to="/showcase" onClick={this.scrollToTop}>Showcase</Link>
              <Link to="/bragging-rights" onClick={this.scrollToTop}>Highlights</Link>
              <Link to="/videos" onClick={this.scrollToTop}>Videos</Link>
              <a href="https://tekdig.com" target="_blank" rel="noopener noreferrer">Blog</a>
              <a
                href="https://portfolio-rudraksh.s3.ap-south-1.amazonaws.com/rudraksh-pathak-resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Resume
              </a>
            </div>

            <div className="footer-social-box">
              <a href="https://github.com/rudrakshpathak" target="_blank" rel="noopener noreferrer" title="GitHub" className="footer-social-btn">
                <i className="fa fa-github"></i>
              </a>
              <a href="https://in.linkedin.com/pub/rudraksh-pathak/25/42/239" target="_blank" rel="noopener noreferrer" title="LinkedIn" className="footer-social-btn">
                <i className="fa fa-linkedin"></i>
              </a>
              <a href="https://twitter.com/rudrapathak" target="_blank" rel="noopener noreferrer" title="Twitter" className="footer-social-btn">
                <i className="fa fa-twitter"></i>
              </a>
              <a href="https://stackoverflow.com/users/3903252/rudraksh-pathak" target="_blank" rel="noopener noreferrer" title="Stack Overflow" className="footer-social-btn">
                <i className="fa fa-stack-overflow"></i>
              </a>
              <a href="https://www.npmjs.com/~rudrakshpathak" target="_blank" rel="noopener noreferrer" title="npm" className="footer-social-btn">
                <i className="fa fa-cube"></i>
              </a>
              <a href="mailto:connect@rudrakshpathak.com" title="Email" className="footer-social-btn">
                <i className="fa fa-envelope-o"></i>
              </a>
            </div>
          </div>

          <div className="footer-bottom-row">
            <p className="footer-copyright">
              &copy; {new Date().getFullYear()} Rudraksh Pathak. Designed with precision &amp; modern engineering.
            </p>

            <button
              type="button"
              className="back-to-top-btn"
              onClick={this.scrollToTop}
              title="Back to Top"
            >
              <span>Back to top</span>
              <i className="fa fa-arrow-up"></i>
            </button>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
